/*
 * Copyright (c) 2025 - 2026. Bluemate B.V.
 */

import React, {useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import PortalSelectController from '../../controls/portalSelect/portalSelectController';

import {NotificationInterval} from '../../../util/enums';

import {PortalSelectOption} from '../../../util/types';

import Notification from '../../../models/notificationModel';

interface Props {
    onChangeNotification: (notification: Notification) => void;
    disabled: boolean;
    notification: Notification;
    withRealtime?: boolean;
}

export default function NotificationIntervalComp(props: Props) {
    const {t} = useTranslation();
    const {onChangeNotification, notification, disabled, withRealtime} = props;
    const items: Array<PortalSelectOption<NotificationInterval>> = useMemo(() => {
        const _items: Array<PortalSelectOption<NotificationInterval>> = [
            {value: NotificationInterval.DAY, label: t('notifications.components.intervalDay', 'dag')},
            {value: NotificationInterval.WEEK, label: t('notifications.components.intervalWeek', 'week')},
            {value: NotificationInterval.MONTH, label: t('notifications.components.intervalMonth', 'maand')}
        ];
        if (withRealtime)
            _items.unshift({
                value: NotificationInterval.INSTANT,
                label: t('notifications.components.intervalInstant', 'direct')
            });
        return _items;
    }, [withRealtime, t]);

    function onChange(value: NotificationInterval | null) {
        if (value === null) return;
        notification.interval = value;
        onChangeNotification(notification);
    }

    return (
        <section>
            <label className='fixed-text'>{t('notifications.components.intervalPerLabel', 'per')}</label>
            <PortalSelectController
                value={notification.interval}
                onChange={onChange}
                items={items}
                placeholder={t('notifications.components.intervalWhen', 'Wanneer')}
                disabled={disabled}
                size='medium'
                outlined
            />
        </section>
    );
}
